module.exports = __webpack_public_path__ + "img/food_roastchicken.244a480c.png";